var _jsxFileName = "/codebuild/output/src286223568/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/BirthdayInput/index.tsx";
import React, { useRef } from 'react';
import { BirthdayPicker, IconChevronDown, IconValidationInvalid, InputPanel, KeyboardlessInput, PICKER_WEB_SCROLL_END_DEBOUNCE_MS } from '@adc/parallax-component-library';
import { DateTimeFormatter, LocalDate } from '@js-joda/core';
import i18n from 'Utilities/i18n';
// initial date is used as date for contents for the input field
const BirthdayInput = ({
  initialDate,
  startDate = LocalDate.now().minusYears(100),
  endDate = LocalDate.now(),
  isTouched,
  errorMessage,
  error,
  testID,
  onDateChange,
  ...props
}) => {
  const currentDateRef = useRef(initialDate ?? LocalDate.now().minusYears(50));
  const handleSelectDate = date => {
    currentDateRef.current = date;
  };
  const hasError = isTouched && error;
  return /*#__PURE__*/React.createElement(KeyboardlessInput, Object.assign({
    placeholder: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.placeholder'),
    label: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.label'),
    "aria-label": i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.label'),
    value: initialDate ? initialDate.format(DateTimeFormatter.ofPattern('MM/dd/yyyy')) : undefined,
    error: hasError,
    supportingIconConfig: hasError ? {
      icon: /*#__PURE__*/React.createElement(IconValidationInvalid, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63,
          columnNumber: 48
        }
      })
    } : undefined,
    supportingText: hasError ? errorMessage : undefined,
    inlineIconConfig: {
      icon: /*#__PURE__*/React.createElement(IconChevronDown, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66,
          columnNumber: 15
        }
      }),
      'aria-label': 'icon',
      color: '$interactive.core.enabled',
      disabledColor: '$interactive.core.disabled'
    },
    testID: testID
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 5
    }
  }), ({
    blurInput,
    hidePanel,
    inputPanelRef
  }) => /*#__PURE__*/React.createElement(InputPanel, {
    ref: inputPanelRef,
    onDismiss: blurInput,
    testID: "date-picker",
    topNavigationProps: {
      title: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.label'),
      buttonEnd: {
        element: i18n.t('Global.microcopy.common.done'),
        onPress: () => {
          setTimeout(() => {
            hidePanel();
            onDateChange(currentDateRef.current);
          }, PICKER_WEB_SCROLL_END_DEBOUNCE_MS + 25);
        }
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(BirthdayPicker, {
    initialDate: currentDateRef.current,
    startDate: startDate,
    endDate: endDate,
    onDateChange: handleSelectDate,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 11
    }
  })));
};
export { BirthdayInput };